import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { catchError, map } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class AuthService {

    private _user: BehaviorSubject<any> = new BehaviorSubject(null);

    readonly user: Observable<boolean> = this._user.asObservable();

    /**
     * Store the URL so we can redirect after logging in
     */
    redirectUrl: string;

    /**
     * Constructor
     *
     * @param _httpClient
     */
    constructor(
        private _httpClient: HttpClient,
        private _router: Router,
    ) { }

    /**
     * Sets session data in local storage
     *
     * @param sessionData
     */
    _setSessionData(sessionData: any) {
        if (sessionData) {
            localStorage.setItem('sessionData', JSON.stringify(sessionData));
        }
    }

    /**
     * Removes local storage from local storage
     */
    private _removeSessionData() {
        localStorage.removeItem('sessionData');
    }

    private _removeAccessToken() {
        localStorage.removeItem('access_token');
    }
    private _removeNewUmToken() {
        const adminUrl = document.location.href.includes('admin');
        const tokenType = adminUrl ? 'private-token' : 'public-token';
        localStorage.removeItem(tokenType);
    }
    /**
     *
     */
    private get _isLoggedIn() {
        const isAdminPage = this._router.url.includes('admin');
        const urlEndPoint = isAdminPage ? 'employee' : 'public';
        this._removeSessionData();
        return (
            this._httpClient
                .get(`/api/v3/session/${urlEndPoint}`)
                // .map((res) => Boolean(res['errors']) ? {} : res)
                .do((res: any) => this._setSessionData(res['result'].data))
        );
    }

    private _saveToken(token: string) {
        if (token) {
            localStorage.setItem('access_token', token);
        }
    }

    /**
     * Returns session data
     */
    get sessionData(): Observable<any> {
        // const sessionData = localStorage.getItem('sessionData');
        // if (sessionData) {
        //   try {
        //     return Observable.of(JSON.parse(sessionData));
        //   } catch (e) {
        //     console.error(e.message);
        //   }
        // }
        return this._isLoggedIn.map((res) => {
            const isAdminPage = this._router.url.includes('admin');
            if (isAdminPage) {
                this.employeeCheckForAdmin().subscribe();
            } else {
                this.employeeCheck().subscribe();
            }
            this._user.next(res['result'].data);
            return res['result'].data;
        });
    }

    /**
     * Login
     *
     * @param data
     */
    login(data: { username: string; password: string }) {
        this._removeSessionData();
        return this._httpClient
            .post('/api/session', { data }, { observe: 'response' })
            .do((res: any) => {
                this._saveToken(res.headers.get('session-token'));
                this._setSessionData(res.body.result.data);
            });
    }

    /**
     * Logout
     */
    logout() {
        return this._httpClient.delete('/api/v3/session', {}).do(() => {
            this._removeSessionData();
            this._removeAccessToken();
            this._removeNewUmToken();
        });
    }

    get checkOldToken() {
        return this._httpClient
            .get('/api/session/uni', { observe: 'response' })
            .pipe(
                map((res) => {
                    if (res.headers.get('session-token')) {
                        localStorage.setItem(
                            'access_token',
                            res.headers.get('session-token')
                        );
                    }
                    return (res.body as any).result.data;
                })
            );
    }

    employeeCheck() {
        return this._httpClient.post('/api/idea/employee/check', {});
    }
    employeeCheckForAdmin() {
        return this._httpClient.post('/api/idea/employee/check/member', {});
    }
    isLoggedIn() {
        ///api/v3/session/employee
        ///api/v3/session/public
        return this._httpClient
            .get<{ result: { data: any } }>('/api/v3/session/public')
            .pipe(
                map((res) => {
                    if (res.result && res.result.data) {
                        this.employeeCheck().subscribe();
                        return true;
                    }
                    return false;
                }),
                catchError(() => of(false))
            );
    }
    issLoggedInPrivate() {
        return this._httpClient
            .get<{ result: { data: any } }>('/api/v3/session/employee')
            .pipe(
                map((res) => {
                    if (res.result && res.result.data) {
                        this.employeeCheckForAdmin().subscribe();
                        return res.result.data;
                    }
                    return false;
                }),
                catchError(() => of(false))
            );
    }
}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/services/auth.service.ts